import { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Grid,
  Button,
  Paper,
  TextField,
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { GetNoticePeriodHelper, UpdateNoticePeriodHelper } from "../helper/NoticePeriodHelper";

const NoticePeriodConfig = () => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
        backgroundColor: "#f3edfd",
      },
    })
  );
  const classes = useStyles();

  const initialValue = {
    notice_period: "30",
  };

  const [inputData, setInputData] = useState(initialValue);
  const [error, setError] = useState(false);
  useEffect(() => {
    GetNoticePeriodHelper().then((res) => {
      if (res?.data?.statuscode === 200) {
        setInputData({
          ...inputData,
          notice_period: res?.data?.data?.[0]?.notice_period_days || "30",
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "notice_period") {
        setError(false);
        setInputData({ ...inputData, [name]: value });
    }
  };
  const handleSubmit = () => {
    if (!inputData?.notice_period?.trim()) {
      setError(true);
      return;
    } 
    setError(false);
    UpdateNoticePeriodHelper({
      notice_period: inputData?.notice_period,
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        setInputData({
          ...inputData,
          notice_period: res?.data?.data[0]?.notice_period_days,
        });
      }
    });
  };

  return (
    <Grid item xs={12}>
      <Paper
        className={classes.Paper}
        sx={{
          padding: "80px 24px 40px",
          borderRadius: "16px",
          width: "100%",
          marginLeft: "0",
        }}
      >
        <Grid container display={"flex"} justifyContent={"space-between"}>
          <Grid item xs={10} md={8}>
            <FormControl fullWidth>
              <TextField
                label="Notice Period (in days)"
                variant="outlined"
                size="small"
                name="notice_period"
                value={inputData?.notice_period}
                onChange={handleInputChange}
                required
                type="number"
                error={error}
                helperText={error ? "Notice period is required" : ""}
              />
            </FormControl>
          </Grid>
          <Grid xs={2} md={3} display={"flex"} justifyContent={"end"}>
            <Box>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                onClick={handleSubmit}
                className="mpl-primary-btn"
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
export default NoticePeriodConfig;
